<template>
  <v-icon
      v-if="link"
      light
      color="black"
      class="ml-2 mr-2"
      @click="onClick"
  >
    mdi-download
  </v-icon>
</template>

<script>
import {toFormAnyBackendLink} from "@/tools/helpers";

export default {
  name: "DownloadComponent",
  props: {
    link: {
      type: String,
      default: null
    }
  },
  methods: {
    onClick() {
      window.open(toFormAnyBackendLink(this.link), '_blank')
    }
  }
}
</script>

<style scoped>

</style>